import { Form, Head } from "@inertiajs/react"
import { useTranslation } from "react-i18next"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Spinner } from "@/components/ui/spinner"
import AuthLayout from "@/layouts/auth-layout"
import { identityPasswordResetPath, signInPath } from "@/routes"

export default function ForgotPassword() {
  const { t } = useTranslation()

  return (
    <AuthLayout
      title={t("auth.password_reset.new.title")}
      description={t("auth.password_reset.new.description")}
    >
      <Head title={t("auth.password_reset.new.page_title")} />

      <div className="space-y-6">
        <Form method="post" action={identityPasswordResetPath()}>
          {({ processing, errors }) => (
            <>
              <div className="grid gap-2">
                <Label htmlFor="email">
                  {t("auth.password_reset.new.email_label")}
                </Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  autoComplete="off"
                  autoFocus
                  placeholder={t("auth.password_reset.new.email_placeholder")}
                />
                <InputError message={errors.email} />
              </div>

              <div className="my-6 flex items-center justify-start">
                <Button className="w-full" disabled={processing}>
                  {processing && <Spinner />}
                  {t("auth.password_reset.new.submit")}
                </Button>
              </div>
            </>
          )}
        </Form>
        <div className="text-muted-foreground space-x-1 text-center text-sm">
          <span>{t("auth.password_reset.new.back_to_sign_in")}</span>
          <TextLink href={signInPath()}>
            {t("auth.password_reset.new.sign_in_link")}
          </TextLink>
        </div>
      </div>
    </AuthLayout>
  )
}
